import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <>
    <title>PetCrew Terms & Conditions | User Agreement & Policies</title>
  <meta name="description" content="Review the terms and conditions for using PetCrew's services. Transparency and trust for every pet parent." />
  <meta name="keywords" content="PetCrew terms, terms and conditions, user policy, pet service agreement, privacy policy" />

    
    <div className="container terms-container py-5">
      <h2 className="mb-4 text-center">Terms & Conditions</h2>

      <p>
        Welcome to <strong>PetCrew</strong>! Your privacy is important to us. This Privacy Policy explains how we collect,
        use, disclose, and safeguard your information when you use our mobile application ("App").
        By using the App, you agree to the terms of this Privacy Policy. If you do not agree, please do not use the App.
      </p>

      <h5>1. Information We Collect</h5>
      <ul>
        <li><strong>Personal Information:</strong> Name, email, phone, gender, dog breed preferences.</li>
        <li><strong>Usage Data:</strong> App usage patterns, preferences, device details.</li>
        <li><strong>Automatically Collected:</strong> IP address, OS, app version.</li>
        <li><strong>Communication Data:</strong> Info collected during support requests.</li>
      </ul>

      <h5>2. How We Use Your Information</h5>
      <ul>
        <li>To enhance and personalize your app experience.</li>
        <li>For account management and login.</li>
        <li>To enable features like pet browsing and matching.</li>
        <li>To send updates, promotions, and support replies.</li>
        <li>To comply with laws and enforce these terms.</li>
      </ul>

      <h5>3. How We Share Your Information</h5>
      <ul>
        <li><strong>With Sellers:</strong> For facilitating listings or inquiries.</li>
        <li><strong>With Service Providers:</strong> For analytics, app performance, support.</li>
        <li><strong>Legal Compliance:</strong> If required by law.</li>
        <li><strong>Business Transfers:</strong> In cases of merger or acquisition.</li>
      </ul>

      <h5>4. Third-Party Services</h5>
      <p>
        The App may link to third-party services like WhatsApp. We do not control or take responsibility for their privacy policies.
      </p>

      <h5>5. Data Security</h5>
      <p>
        We apply security best practices, but we cannot guarantee complete safety of your data over the internet.
      </p>

      <h5>6. Your Rights & Choices</h5>
      <ul>
        <li>Update your data via App settings.</li>
        <li>Request account deletion at <a href="mailto:infopetcrew@gmail.com">infopetcrew@gmail.com</a>.</li>
        <li>Unsubscribe from marketing through email links.</li>
      </ul>

      <h5>7. Children's Privacy</h5>
      <p>
        Users must be 18+. Parental consent is needed if younger. We don’t knowingly collect info from children under 13.
      </p>

      <h5>8. Changes to this Privacy Policy</h5>
      <p>
        Policy updates will be posted in the app. Continued use means you accept the updated terms.
      </p>

      <h5>9. Contact Us</h5>
      <p>
        For questions or concerns:
        <br />Email: <a href="mailto:infopetcrew@gmail.com">infopetcrew@gmail.com</a>
        <br />Phone: +91 8800864674
        <br />Address: A112, 4th Floor, Sector 79B, Gurgaon
      </p>

      <p className="mt-4">
        By using PetCrew, you acknowledge that you have read and understood this Privacy Policy.
      </p>
    </div>
    </>
  );
};

export default TermsAndConditions;
